import { render, staticRenderFns } from "./DesktopOffersIndFamTemp.vue?vue&type=template&id=78328c19"
import script from "./DesktopOffersIndFamTemp.vue?vue&type=script&lang=js"
export * from "./DesktopOffersIndFamTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports